import { SxProps, Theme } from '@mui/material'

/** Shared panel padding/indent for all chart settings tabs */
export const chartSettingsTabPanelSx: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
    pl: '9px',
    '& .MuiFormGroup-root': {
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
    },
}

export const chartSettingsSectionTitleSx = {
    fontSize: '11px',
    marginBottom: 1.5,
    color: (theme: Theme) => theme.palette.text.secondary,
}

export const chartSettingsSectionDividerSx = {
    marginTop: 2.5,
    marginBottom: 1.5,
}

export const chartSettingsFormGroupSx: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
}

export const chartSettingsRowSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    minHeight: 36,
    gap: 1,
}

/** Flex row for label/checkbox + color picker — labels stay on one line. */
export const chartSettingsColorRowSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    minHeight: 36,
    gap: 1,
    flexWrap: 'nowrap',
}

/** Two-column row: label + controls (colors, inputs, etc.) */
export const chartSettingsGridRowSx: SxProps<Theme> = {
    display: 'grid',
    gridTemplateColumns: '180px 1fr',
    alignItems: 'center',
    minHeight: 36,
    columnGap: 1,
    width: '100%',
}

export const chartSettingsLabelSx: SxProps<Theme> = {
    width: 100,
    fontSize: '14px',
    flexShrink: 0,
}

/** Label on rows that include a color picker — fixed width, no wrapping. */
export const chartSettingsColorRowLabelSx: SxProps<Theme> = {
    fontSize: '14px',
    flexShrink: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'inline-block',
    verticalAlign: 'middle',
    width: '180px',
}

export const chartSettingsCheckboxLabelSx: SxProps<Theme> = {
    width: 100,
    flexShrink: 0,
    ml: 0,
    mr: 0,
    '& .MuiFormControlLabel-label': { 
        fontSize: '14px',
        whiteSpace: 'nowrap',
    },
}

/** Checkbox label on rows that include a color picker — no fixed width, no wrapping. */
export const chartSettingsCheckboxColorLabelSx: SxProps<Theme> = {
    flexShrink: 0,
    ml: 0,
    mr: 0,
    width: 'auto',
    '& .MuiFormControlLabel-label': {
        fontSize: '14px',
        whiteSpace: 'nowrap',
    },
}

export const chartSettingsFormControlLabelSx: SxProps<Theme> = {
    width: 100,
    flexShrink: 0,
    ml: 0,
    mr: 0,
    '& .MuiFormControlLabel-label': { fontSize: '14px' },
}

export const chartSettingsRowControlsSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    minWidth: 0,
}

/** MuiCheckbox root width: 4px padding × 2 + 24px icon (see theme MuiCheckbox.styleOverrides). */
export const chartSettingsCheckboxWidth = '32px'

export const chartSettingsCheckboxCaptionSx: SxProps<Theme> = {
    display: 'block',
    pl: chartSettingsCheckboxWidth,
    lineHeight: 1.4,
    color: (theme) => theme.palette.text.tertiary,
}
